import type { Theme } from '@mui/material/styles';

import type { ChatViewMode } from 'components/ChatLauncher/ChatDockContext';

export const getChatPanelZIndex = (theme: Theme, viewMode: ChatViewMode): number => {
  // The docked panel is a fixed-position portal to document.body, so it can end up sharing
  // horizontal space with the persistent left nav (Header) at narrow viewport widths. The left
  // nav uses theme.zIndex.drawer for its own z-index (commonNavStyles.ts / Header/index.tsx) and
  // is always mounted first (it's part of the permanent app shell), so matching that same value
  // here — rather than picking a numerically higher one — lets DOM order do the work: the docked
  // panel's portal node is always appended to document.body after the nav's, so at equal z-index
  // it paints on top without needing an explicit z-index advantage over the nav.
  if (viewMode === 'docked') return theme.zIndex.drawer;

  return theme.zIndex.modal;
};
